<script setup lang="ts">
const columns = [
  {
    label: "Resources",
    children: [
      {
        label: "Help center",
        to: "https://colibriocirrus.atlassian.net/helpcenter/support",
        target: "_blank",
      },
      {
        label: "Docs",
        icon: "hugeicons:coming-soon-01",
      },
    ],
  },
  {
    label: "Features",
    children: [
      {
        label: "Coming Soon",
        icon: "hugeicons:coming-soon-01",
      },
    ],
  },
  {
    label: "Company",
    children: [
      {
        label: "About",
        icon: "hugeicons:coming-soon-01",
      },
      {
        label: "Pricing",
        icon: "hugeicons:coming-soon-01",
      },
    ],
  },
];
</script>

<template>
  <USeparator class="h-px" />

  <UFooter :ui="{ top: 'border-b border-default' }">
    <template #top>
      <UContainer>
        <UFooterColumns :columns="columns" :ui="{ center: 'xl:col-span-3' }" />
      </UContainer>
    </template>

    <template #left>
      <p class="text-muted text-sm">
        Colibrio Cirrus AB © {{ new Date().getFullYear() }} - Powered by the
        <a href="https://www.colibrio.com" target="_blank"
          >Colibrio Reader Framework</a
        >
      </p>
    </template>
  </UFooter>
</template>
